<template>
	<div id="area_left3">
		<div class="cc-header">设备使用分析</div>
		<div class="main-value" id="device_use"></div>
	</div>
</template>
<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
const echarts = require("echarts");
export default {
	data() {
		return {};
	},
	mounted() {
		this.initData();
		// 定时器刷新，1天
		let _this = this;
		this.interval = setInterval(() => {
			_this.initData();
		}, 1000 * 60 * 60 * 24);
	},
	methods: {
		initData() {
			// 基于准备好的dom，初始化echarts实例
			let deviceTypeChart = echarts.init(
				document.getElementById("device_use")
			);
			this.$http.get("/dataView/platform/getDeviceType?orgCode=" + orgCode).then(res => {
				if (res.data.code === 200) {
					var result = [];
					if (res.data.result.length > 0) {
						for (var i = 0; i < res.data.result.length; i++) {
							var obj = res.data.result[i];
							result.push({ name: obj.name, value: obj.value });
						}
					} else {
						result.push({ name: '设备', value: 0 });
					}
					var option = {
						color: ['#8BC34A','#673AB7','#FF9800','#00BCD4','#fd87ab','#11abff','#ffdf33','#968ade','#c23531','#795548','#61a0a8','#d48265','#749f83','#ca8622','#48cda6'],
						tooltip: {
							trigger: 'item'
						},
						legend: {
							show: false,
							orient: 'vertical',
							top: 20,
							right: 20,
							textStyle: {
								fontSize: fontSize(0.12),
								color: '#34deff' // 把颜色这里做成函数就可以了
							},
							itemWidth: 12,
							itemHeight: 6
						},
						series: [{
							name: '数量',
							type: 'pie',
							radius: '75%',
							center: ['50%', '45%'],
							label: {
								normal: {
									formatter(v) {
										let text = v.name + ' : ' + v.value
										if (text.length <= 12) {
											return text;
										} else if (text.length > 12 && text.length <= 16) {
											return text = `${text.slice(0, 12)}:${text.slice(12)}`
										} else if (text.length > 16 && text.length <= 24) {
											return text = `${text.slice(0, 12)}:${text.slice(12, 16)}:${text.slice(16)}`
										} else if (text.length > 24 && text.length <= 30) {
											return text = `${text.slice(0, 12)}:${text.slice(12, 16)}:${text.slice(16, 24)}:${text.slice(24)}`
										} else if (text.length > 30) {
											return text = `${text.slice(0, 12)}:${text.slice(12, 16)}:${text.slice(16, 24)}:${text.slice(24, 30)}:${text.slice(30)}`
										}
									},
								}
							},
							data: result,
							itemStyle: {
								normal: {
									label: {
										textStyle: {
											color: '#34deff',
											fontSize: fontSize(0.12)
										}
									}
								}
							},
							emphasis: {
								itemStyle: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.5)'
								}
							}
						}]
					};
					deviceTypeChart.setOption(option);
					// 响应式变化
					window.addEventListener("resize", () => deviceTypeChart.resize(), false);
				}
			});
		}
	},
	beforeDestroy() {
		clearInterval(this.interval);
	},
	destroyed() {
		window.onresize = null;
	}
};
function fontSize(res) {
	let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	if (!clientWidth) return;
	let fontSize = 100 * (clientWidth / 1920);
	return res * fontSize;
}
</script>

<style lang="scss">
#area_left3 {
	height: 100%;

	.cc-header {
		width: 100%;
		text-align: center;
		background: url("../../assets/img/cam_titbgsmall02.png") center no-repeat;
		background-size: 100%;
		color: #34deff;
		font-size: 0.2rem;
		font-weight: bold;
		height: 0.8rem;
		line-height: 0.6rem;
	}

	.main-value {
		height: 80%;
	}
}
</style>